<template>
  <a
    v-if="context.request.user.is_staff && context.flavour === 'full'"
    class="background-yellow text-body-2 pa-1"
    target="_blank"
    rel="noopener noreferrer"
    :href="link || ''"
  >
    {{ text }}
  </a>
</template>

<script setup lang="ts">
import type { ContextStore } from 'src/components/common/AdminButton/types'
import { useContextStore } from 'src/store'

const { context }: ContextStore = useContextStore()

defineProps<{
  link?: string
  text: string
}>()
</script>

<style lang="scss" scoped>
.background-yellow {
  display: inline-block;
  border-radius: 4px;
  background-color: yellow;
}
</style>
